import { missingTranslationString } from '../translation-module.config';

export function translationKeyExists(translation: unknown, key: string) {
  return translation !== missingTranslationString(key) && translation !== key;
}
